import React from 'react';
import PropTypes from 'prop-types';

const UnstyledDropdownToggle = React.forwardRef(
  ({ children, onClick, role, tabIndex, ...props }, ref) => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (onClick) {
          onClick(e);
        }
      }
    };

    return (
      <div
        {...props}
        ref={ref}
        role={role || 'button'}
        tabIndex={tabIndex ?? 0}
        onClick={onClick}
        onKeyDown={handleKeyDown}
      >
        {children}
      </div>
    );
  }
);

UnstyledDropdownToggle.displayName = 'UnstyledDropdownToggle';

UnstyledDropdownToggle.propTypes = {
  children: PropTypes.node,
  role: PropTypes.string,
  tabIndex: PropTypes.number,
  onClick: PropTypes.func,
};

export default UnstyledDropdownToggle;
